"use client";
import React from "react";
import { motion } from "framer-motion";
import Image from "next/image";

const alumni = [
  {
    name: "Saurabh Chauhan",
    course: "BTECH | CSE 2016–20",
    image: "/images/alumuni3.png",
    message:
      "SCE prepares the players to be leaders. Academic experience received at SCE was wonderful, as all our faculty provided individual support and practical exposure. The opportunities and training at SCE helped me develop the skills and adaptability needed throughout my career.",
  },
  {
    name: "Vishal",
    course: "BTECH | CSE",
    image: "/images/almunI2.jpg",
    message:
      "I am extremely grateful to have attended Shivalik College of Engineering for my Computer Science degree. The education I received was top-notch, and the professors were knowledgeable, engaging, and always willing to help.",
  },
  {
    name: "Ankita Sharma",
    course: "BTECH | ECE 2017–21",
    image: "/images/alumni1.jpg",
    message:
      "My journey at SCE was filled with knowledge, support, and opportunities that shaped my professional life. I’ll always cherish the environment that encouraged creativity and leadership.",
  },
  {
    name: "Rahul Verma",
    course: "MBA | 2018–20",
    image: "/images/alumuni6.png",
    message:
      "Shivalik College gave me the confidence and vision to pursue my dreams. The practical learning environment and experienced faculty made all the difference.",
  },
];

export default function Alumni() {
  return (
    <section className="bg-gradient-to-b from-white to-teal-50 py-20 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 text-center mb-14">
          Alumni Voice
        </h2>

        {/* Auto-scrolling track */}
        <div className="relative w-full overflow-hidden">
          <motion.div
            className="flex gap-8"
            animate={{ x: ["0%", "-100%"] }}
            transition={{
              duration: 35,
              ease: "linear",
              repeat: Infinity,
            }}
          >
            {/* Duplicate the alumni array to make a seamless loop */}
            {[...alumni, ...alumni].map((alum, index) => (
              <div
                key={index}
                className="min-w-[300px] sm:min-w-[350px] bg-teal-700 text-white rounded-2xl shadow-xl flex flex-col justify-between p-6 hover:scale-105 transition-transform duration-300"
              >
                <div className="flex items-center gap-4 mb-4">
                  <div className="relative w-20 h-20 flex-shrink-0">
                    <Image
                      src={alum.image}
                      alt={alum.name}
                      fill
                      className="object-cover rounded-xl border-2 border-yellow-400"
                    />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold">{alum.name}</h3>
                    <p className="text-sm text-gray-200">{alum.course}</p>
                  </div>
                </div>
                <p className="text-sm md:text-base leading-relaxed text-gray-100">
                  {alum.message}
                </p>
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
}